import React from "react"
import { componentStyles, useTheme } from "@mallardbay/lib-react-components"
import { faPaw } from "@fortawesome/free-solid-svg-icons/faPaw"
import { faShip } from "@fortawesome/free-solid-svg-icons/faShip"
import { faHouseChimney } from "@fortawesome/free-solid-svg-icons/faHouseChimney"

import Tag from "~components/shared/todo-lib-react-components/tag"
import { ListingType } from "~graphql/generated/graphql"
import { getListingTypeCamelcase } from "~utils/helpers"

interface Props {
    readonly type?: ListingType | null
}

export default function ListingTypePill({ type }: Props) {
    const listingType = getListingTypeCamelcase(type)
    const typeIcon = getIcon(type)
    const styles = useStyleProps()

    return (
        <Tag leftIcon={typeIcon} style={styles.tag}>
            {listingType}
        </Tag>
    )
}

function useStyleProps() {
    const { colors } = useTheme()

    return componentStyles({
        tag: {
            backgroundColor: colors.backgroundSecondary,
            borderColor: colors.backgroundSecondary,
        },
    })
}

function getIcon(type?: ListingType | null) {
    switch (type) {
        case ListingType.LodgingOnly:
            return faHouseChimney
        case ListingType.Fishing:
            return faShip
        default:
            return faPaw
    }
}
